module.exports = __webpack_public_path__ + "static/media/Logo.fedef93c.png";